import { useQuery } from "@tanstack/react-query";
import { fetchProducts } from "../api/productApi";
// import { fetchProducts } from "../api/productsApi";

export const useProducts = () => {
  return useQuery({
    queryKey: ["products"],
    queryFn: fetchProducts,
  });
};
